import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function DisplayOrientationBulkBar({
  selectedCount,
  totalCount,
  allSelected,
  onToggleSelectAll,
  onApplySelected,
  onApplyAll,
  saving = false,
}) {
  const { t } = useTranslation();
  const [pending, setPending] = useState("");

  const run = async (orientation, all) => {
    const key = `${all ? "all" : "sel"}-${orientation}`;
    setPending(key);
    try {
      if (all) await onApplyAll(orientation);
      else await onApplySelected(orientation);
    } finally {
      setPending("");
    }
  };

  return (
    <div className="kitchen-orient-bulk">
      <label className="kitchen-orient-bulk__select">
        <input
          type="checkbox"
          checked={allSelected}
          onChange={onToggleSelectAll}
          disabled={totalCount === 0 || saving}
        />
        <span>
          {t("selectAll")}
          {selectedCount ? ` (${selectedCount})` : ""}
        </span>
      </label>
      <div className="kitchen-orient-bulk__actions">
        <span className="kitchen-orient-bulk__label">
          {t("applyOrientation")}
        </span>
        <button
          type="button"
          className="kitchen-orient-bulk__btn"
          disabled={saving || selectedCount === 0 || Boolean(pending)}
          onClick={() => run("vertical", false)}
        >
          <i className="fas fa-grip-vertical" aria-hidden />
          {t("vertical")}
        </button>
        <button
          type="button"
          className="kitchen-orient-bulk__btn"
          disabled={saving || selectedCount === 0 || Boolean(pending)}
          onClick={() => run("horizontal", false)}
        >
          <i className="fas fa-grip-horizontal" aria-hidden />
          {t("horizontal")}
        </button>
        <button
          type="button"
          className="kitchen-orient-bulk__btn kitchen-orient-bulk__btn--all"
          disabled={saving || totalCount === 0 || Boolean(pending)}
          onClick={() => run("vertical", true)}
        >
          {t("allVertical")}
        </button>
        <button
          type="button"
          className="kitchen-orient-bulk__btn kitchen-orient-bulk__btn--all"
          disabled={saving || totalCount === 0 || Boolean(pending)}
          onClick={() => run("horizontal", true)}
        >
          {t("allHorizontal")}
        </button>
      </div>
    </div>
  );
}
